import { OrganizationWorkspace } from "@/components/orgs/organization-workspace";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization")({
  component: () => (
    <OrganizationWorkspace>
      <Outlet />
    </OrganizationWorkspace>
  ),
  head: () => ({ meta: [{ title: "Papier - Organization" }] }),
});
